module.exports = __webpack_public_path__ + "static/media/Google_Button@3x.3831b377.png";